import { columnDef_header_Z721C83C5, columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, ColumnHelper_accessor_36841BC5, columnDef_footer_Z5FD1F5D2, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, ColumnHelper_accessor_10721996, ColumnHelper_createColumnHelper_Z2906D979 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { empty, singleton, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { Record, Union } from "../fable_modules/fable-library.3.7.1/Types.js";
import { class_type, record_type, union_type, int32_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { MakeData_makeCreatedAt, Types_PersonCreatedAt$reflection } from "../MakeData.fs.js";
import { Table_getFooterGroups_Z4395D14A, Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_paginationRowModel, tableProps_sortedRowModel, tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_hasNextPage_Z4395D14A, Table_hasPreviousPage_Z4395D14A, Table_getPageCount_Z4395D14A, Table_setPageIndex, Table_nextPage_Z4395D14A, Table_previousPage_Z4395D14A, Table_setPageSize } from "../../Feliz.TanStack.Table/Pagination.fs.js";
import { Column_getIsSorted_Z2685F962, Column_getCanSort_Z2685F962, Column_toggleSorting_Z2685F962 } from "../../Feliz.TanStack.Table/Sorting.fs.js";
import { singleton as singleton_1, map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { round, int32ToString, createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Header_isPlaceholder_315F98D7 } from "../../Feliz.TanStack.Table/Header.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { FSharpMap__get_Item, ofList } from "../fable_modules/fable-library.3.7.1/Map.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.1/Range.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { Table_getState_Z4395D14A } from "../../Feliz.TanStack.Table/TableState.fs.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export const columnDef = ColumnHelper_createColumnHelper_Z2906D979(ofArray([ColumnHelper_accessor_10721996("firstname", ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((info_1) => info_1.column.id)])), ColumnHelper_accessor_36841BC5((p) => p.Lastname, ofArray([columnDef_id_Z721C83C5("lastName"), columnDef_cell_Z1DDB00E5((info_2) => createElement("i", {
    children: info_2.getValue(),
})), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((info_3) => info_3.column.id)])), ColumnHelper_accessor_10721996("Age", ofArray([columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((info_4) => info_4.column.id)])), ColumnHelper_accessor_10721996("Visits", ofArray([columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((info_5) => info_5.column.id)])), ColumnHelper_accessor_10721996("Status", ofArray([columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((info_6) => info_6.column.id)])), ColumnHelper_accessor_10721996("Progress", ofArray([columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((info_7) => info_7.column.id)])), ColumnHelper_accessor_10721996("CreatedAt", singleton(columnDef_header_Z721C83C5("Created At")))]));

export class PaginateChange extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["First", "Previous", "Next", "Last", "Index"];
    }
}

export function PaginateChange$reflection() {
    return union_type("Examples.Sorting.PaginateChange", [], PaginateChange, () => [[], [], [], [], [["Item", int32_type]]]);
}

export class PageState extends Record {
    constructor(PageIndex, PageSize) {
        super();
        this.PageIndex = (PageIndex | 0);
        this.PageSize = (PageSize | 0);
    }
}

export function PageState$reflection() {
    return record_type("Examples.Sorting.PageState", [], PageState, () => [["PageIndex", int32_type], ["PageSize", int32_type]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Paginate", "PageSizeChange", "SortColumn"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Sorting.Msg", [], Msg, () => [[["Item", PaginateChange$reflection()]], [["Item", int32_type]], [["Item", class_type("Feliz.TanStack.Table.Types.Column`1", [Types_PersonCreatedAt$reflection()])]]]);
}

export class State extends Record {
    constructor(Table, PageState) {
        super();
        this.Table = Table;
        this.PageState = PageState;
    }
}

export function State$reflection() {
    return record_type("Examples.Sorting.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Types_PersonCreatedAt$reflection()])], ["PageState", PageState$reflection()]]);
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", MakeData_makeCreatedAt(1000)], tableProps_columns_Z2906D979(columnDef), tableProps_sortedRowModel(), tableProps_paginationRowModel()])), new PageState(0, 10)), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            return [new State(Table_setPageSize(msg.fields[0], state.Table), state.PageState), Cmd_none()];
        }
        case 2: {
            Column_toggleSorting_Z2685F962(msg.fields[0]);
            return [new State(state.Table, state.PageState), Cmd_none()];
        }
        default: {
            const paginateChange = msg.fields[0];
            return [new State((paginateChange.tag === 1) ? Table_previousPage_Z4395D14A(state.Table) : ((paginateChange.tag === 2) ? Table_nextPage_Z4395D14A(state.Table) : ((paginateChange.tag === 3) ? Table_setPageIndex(Table_getPageCount_Z4395D14A(state.Table) - 1, state.Table) : ((paginateChange.tag === 4) ? Table_setPageIndex(paginateChange.fields[0] - 1, state.Table) : Table_setPageIndex(0, state.Table)))), state.PageState), Cmd_none()];
        }
    }
}

export function view(state, dispatch) {
    let elems_8, children_8, properties_8, elems_7, elems_6, elems_10;
    let thead;
    const children = toList(delay(() => map((headerGroup) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_2 = toList(delay(() => map((header) => {
            let elems_1;
            return createElement("th", createObj(ofArray([["key", header.id], (elems_1 = toList(delay(() => {
                let properties, elems, matchValue;
                return Header_isPlaceholder_315F98D7(header) ? singleton_1(null) : singleton_1(createElement("div", createObj(ofArray([(properties = (Column_getCanSort_Z2685F962(header.column) ? ofArray([["cursor", "pointer"], ["userSelect", "none"]]) : empty()), ["style", createObj(properties)]), ["onClick", (_arg1) => {
                    dispatch(new Msg(2, header.column));
                }], (elems = [Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header)), (matchValue = Column_getIsSorted_Z2685F962(header.column), (matchValue.tag === 1) ? "🔽" : ((matchValue.tag === 2) ? "" : "🔼"))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let tbody;
    const children_4 = toList(delay(() => map((row) => {
        let elems_3;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_3 = toList(delay(() => map((cell) => {
            const children_2 = singleton(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tfoot;
    const children_6 = toList(delay(() => map((footerGroup) => {
        let elems_5;
        return createElement("tr", createObj(ofArray([["key", footerGroup.id], (elems_5 = toList(delay(() => map((footer) => {
            let elems_4;
            return createElement("th", createObj(ofArray([["key", footer.id], (elems_4 = [Html_flexRender_Z6DEE00B4(footer.column.columnDef.footer, Table_getContext_315F98D7(footer))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
        }, footerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    }, Table_getFooterGroups_Z4395D14A(state.Table))));
    tfoot = createElement("tfoot", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    let paginationControls;
    const selectOptions = ofList(toList(delay(() => map((i) => [int32ToString(i), [`Show ${i}`, () => {
        dispatch(new Msg(1, i));
    }]], rangeDouble(10, 10, 50)))));
    const pageControl = (text, isDisabled, onClick) => createElement("button", {
        className: join(" ", ["button"]),
        children: text,
        disabled: isDisabled,
        onClick: onClick,
    });
    paginationControls = createElement("div", createObj(ofArray([["className", join(" ", ["is-inline-block"])], (elems_8 = [pageControl("\u003c\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg3) => {
        dispatch(new Msg(0, new PaginateChange(0)));
    }), pageControl("\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg4) => {
        dispatch(new Msg(0, new PaginateChange(1)));
    }), pageControl("\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg5) => {
        dispatch(new Msg(0, new PaginateChange(2)));
    }), pageControl("\u003e\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg6) => {
        dispatch(new Msg(0, new PaginateChange(3)));
    }), (children_8 = ofArray(["Page ", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1, " of ", Table_getPageCount_Z4395D14A(state.Table), " | Go to page:"]), createElement("p", {
        children: Interop_reactApi.Children.toArray(Array.from(children_8)),
    })), createElement("input", createObj(ofArray([["className", join(" ", ["input"])], ["type", "number"], (properties_8 = singleton(["width", 4 + "rem"]), ["style", createObj(properties_8)]), ["defaultValue", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1], ["onChange", (ev) => {
        const value_46 = ev.target.valueAsNumber;
        if ((!(value_46 == null)) && (!Number.isNaN(value_46))) {
            dispatch(new Msg(0, new PaginateChange(4, round(value_46))));
        }
    }]]))), createElement("div", createObj(ofArray([["className", join(" ", ["select"])], (elems_7 = [createElement("select", createObj(ofArray([["onChange", (event) => {
        FSharpMap__get_Item(selectOptions, event.target.value)[1]();
    }], ["value", `${Table_getState_Z4395D14A(state.Table).pagination.pageSize}`], (elems_6 = toList(delay(() => map((option) => createElement("option", {
        key: option[0],
        value: option[0],
        children: option[1][0],
    }), selectOptions))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])));
    return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_10 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody, tfoot]),
    }), paginationControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Sorting.fs.js.map
